import styled from '../../../../../theme/styled';

const TopBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

const BottomBlock = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  flex-grow: 1;
`;

const ActionsBlock = styled.div`
  display: flex;
  flex: row;
  flex-wrap: nowrap;
  width: 100%;
`;

export default {
  TopBlock,
  BottomBlock,
  ActionsBlock,
};
